module.exports = __webpack_public_path__ + "img/picture.29af873f.svg";